import axios from 'axios';
// import Error from 'components/alerts/Error'
import { Info } from 'components/common/form/modules/Info';
import React from 'react';
import { AppConfig } from '../../config/app';

export default class ImageUpload extends React.Component<
  { [label: string]: any },
  { [label: string]: any }
> {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      isUploading: false,
      emptyFile: false,
    };

    this.onChange = this.onChange.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  public onChange(e) {

    if (e.target.files[0].size > 1048576) {
      alert("Exceeded image size limit (1MB)!\nRecommended image resolution: 1000px x 400px");
      return undefined;
    };

    this.setState({
      file: e.target.files[0],
      imgSrc: "",
      emptyFile: false,
      isUploading: false
    });
  }
  public onSubmit(e) {
    e.preventDefault();
    this.setState({
      emptyFile: false
    });
    if (this.state.file == null) {
      this.setState({
        emptyFile: true
      });
      alert('Please choose file first')
      return;
    }
    this.setState({
      isUploading: true
    });
    this.fileUpload(this.state.file).then(response => {
      const { data } = response;
      if (data.status === "success") {
        this.setState({
          isUploading: false
        });
        this.props.onUpload(data.url);
      } else {
        this.setState({
          isUploading: false
        });
      }
    });
  }

  public fileUpload(file) {
    const url = AppConfig.apiUrl + "/api/upload";
    const formData = new FormData();
    formData.append("attachment", file);
    formData.append("typeOfUpload", "event-promotional");
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return axios.post(url, formData, config);
  }

  public render() {
    const { imgSrc } = this.props;
    return (
      <div style={{ paddingTop: this.props.background ? '20px' : '0px' }}>
        {
          this.props.avatar && imgSrc === 'https://platform.isotopeticketing.com/landing.png' ?
            <h5 style={{ paddingLeft: '20px' }}>
              No profile picture
          </h5> :
            (this.props.background ?
              <h6 style={{ paddingLeft: '20px' }}>
                Seating Layout Image
              </h6>
              :
              <img
                src={imgSrc}
                style={
                  this.props.avatar ?
                    {
                      width: '50px', height: '50px', marginBottom: '10px', borderRadius: '25px',
                      boxShadow: imgSrc === 'https://platform.isotopeticketing.com/landing.png' ?
                        'none' :
                        'inset 0px 2px 10px 0px rgba(0, 0, 0, 0.4)',
                      objectFit: 'cover',
                      marginLeft: '20px'
                    }
                    : {
                      width: '100%', marginBottom: '10px',
                      boxShadow: imgSrc === 'https://platform.isotopeticketing.com/landing.png' ?
                        'none' :
                        'inset 0px 2px 10px 0px rgba(0, 0, 0, 0.4)'
                    }
                }
                key={imgSrc}
              />)
        }
        <form onSubmit={this.onSubmit} style={{ justifyContent: 'center', textAlign: 'left', paddingLeft: '20px' }} className='file-upload-container'>
          <input
            type="file"
            onChange={this.onChange}
            className="cut-text border-0"
            style={{
              backgroundColor: '#f8f8f8',
              marginRight: 'auto', marginLeft: 'auto'
            }}
          />
          <br />
          <button
            className="new-button-white-4"
            disabled={this.state.isUploading}
          >
            {this.state.isUploading ? "UPLOADING..." : "UPLOAD"}
          </button>
          <Info>
            {"Choose file first (<1MB), then click 'UPLOAD' & finally click 'SAVE'."}
          </Info>
        </form>
        {/* {this.state.emptyFile ? <div style={{ paddingTop: '110px' }}><Error content="Please choose file first" /></div> : null} */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/upload/ImageUpload.tsx